import { render, staticRenderFns } from "./match-scan.vue?vue&type=template&id=31e6989e"
import script from "./match-scan.vue?vue&type=script&lang=js"
export * from "./match-scan.vue?vue&type=script&lang=js"
import style0 from "./match-scan.vue?vue&type=style&index=0&id=31e6989e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports